import { defineMessages } from 'react-intl';

export default defineMessages({
  breadcrumbEmployeeRoleList: {
    id: 'employeeRole.breadcrumb.list',
    defaultMessage: 'Employee Role List',
  },
  breadcrumbRegister: {
    id: 'employeeRoleRegister.breadcrumb.register',
    defaultMessage: 'Register New Employee Role',
  },
  breadcrumbEdit: {
    id: 'employeeRoleRegister.breadcrumb.edit',
    defaultMessage: 'Edit Employee Role',
  },
  btnEdit: {
    id: 'employeeRoleRegister.form.btn.edit',
    defaultMessage: 'Edit',
  },
  btnSave: {
    id: 'employeeRoleRegister.form.btn.save',
    defaultMessage: 'Save',
  },
  registerRoleTitle: {
    id: 'employeeRoleRegister.form.title.register',
    defaultMessage: 'Create New Employee Roles',
  },
  editRoleTitle: {
    id: 'employeeRoleRegister.form.title.edit',
    defaultMessage: 'Edit Employee Roles',
  },
  formLabelEmployeeRoleName: {
    id: 'employeeRoleRegister.form.label.employeeRoleName',
    defaultMessage: 'Employee Role Name',
  },
  formRequiredEmployeeRoleName: {
    id: 'employeeRoleRegister.form.validation.required.employeeRoleName',
    defaultMessage: 'Employee Role Name required',
  },
  formPlaceholderEmployeeRoleName: {
    id: 'employeeRoleRegister.form.placeholder.employeeRoleName',
    defaultMessage: 'Enter employee role name',
  },
  formLabelEmployeeRoleDescription: {
    id: 'employeeRoleRegister.form.label.employeeRoleDescription',
    defaultMessage: 'Employee Role Description',
  },
  formRequiredEmployeeRoleDescription: {
    id: 'employeeRoleRegister.form.validation.required.employeeRoleDescription',
    defaultMessage: 'Employee Role Description required',
  },
  formPlaceholderEmployeeRoleDescription: {
    id: 'employeeRoleRegister.form.placeholder.employeeRoleDescription',
    defaultMessage: 'Enter employee role description',
  },
  formLabelCompanyRoles: {
    id: 'employeeRoleRegister.form.label.companyRoles',
    defaultMessage: 'Company Roles',
  },
  formLabelEmployeePermission: {
    id: 'employeeRoleRegister.form.label.employeePermission',
    defaultMessage: 'Employee Permission',
  },
  formLabelSection: {
    id: 'employeeRoleRegister.form.label.section',
    defaultMessage: 'Section',
  },
  formLabelPermission: {
    id: 'employeeRoleRegister.form.label.permission',
    defaultMessage: 'Permission',
  },
  formLabelAction: {
    id: 'employeeRoleRegister.form.label.action',
    defaultMessage: 'Action',
  },
  formLabelModule: {
    id: 'employeeRoleRegister.form.label.module',
    defaultMessage: 'Module',
  },
  formLabelSubModule: {
    id: 'employeeRoleRegister.form.label.subModule',
    defaultMessage: 'Sub-Module',
  },
  formLabelCreate: {
    id: 'employeeRoleRegister.form.label.create',
    defaultMessage: 'Create',
  },
  formLabelRead: {
    id: 'employeeRoleRegister.form.label.read',
    defaultMessage: 'Read',
  },
  formLabelUpdate: {
    id: 'employeeRoleRegister.form.label.update',
    defaultMessage: 'Update',
  },
  formLabelDelete: {
    id: 'employeeRoleRegister.form.label.delete',
    defaultMessage: 'Delete',
  },
  registerRoleSuccessMessage: {
    id: 'employeeRoleRegister.form.message.successRegister',
    defaultMessage: 'Employee Role success created',
  },
  updateRoleSuccessMessage: {
    id: 'employeeRoleRegister.form.message.successUpdate',
    defaultMessage: 'Employee Role success updated',
  },
  validationPermission: {
    id: 'employeeRoleRegister.form.validation.required.employeePermission',
    defaultMessage: 'Choose at least one of Employee permission',
  },
  validationCompanyRole: {
    id: 'employeeRoleRegister.form.validation.required.companyRole',
    defaultMessage: 'Select one more of company roles',
  },
  validationSubModule: {
    id: 'employeeRoleRegister.form.validation.required.subModule',
    defaultMessage: 'Choose at least one Sub-module per Module',
  },
});
